import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const FormGroup = styled.div`
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
`

export const FormLabel = styled.label`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #374151;
	margin-bottom: 8px;
`

export const FormInput = styled.input`
	width: 100%;
	padding: 12px 16px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const FormTextarea = styled.textarea`
	width: 100%;
	padding: 12px 16px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	font-family: inherit;
	resize: vertical;
	min-height: 80px;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const FormSelect = styled.select`
	width: 100%;
	padding: 12px 48px 12px 16px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	background-color: white;
	cursor: pointer;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right 16px center;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	& option {
		padding: 8px;
	}
`

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'danger' }>`
	padding: 12px 24px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	border: none;

	${({ variant = 'secondary' }) => {
		switch (variant) {
		case 'primary':
			return `
				background-color: ${orange};
				color: white;

				&:hover:not(:disabled) {
					opacity: 0.9;
				}

				&:disabled {
					opacity: 0.5;
					cursor: not-allowed;
				}
			`
			case 'danger':
				return `
					background-color: #dc2626;
					color: white;

					&:hover:not(:disabled) {
						background-color: #b91c1c;
					}

					&:disabled {
						background-color: #9ca3af;
						cursor: not-allowed;
					}
				`
		default:
			return `
				background-color: white;
				color: #374151;
				border: 1px solid #d1d5db;

				&:hover {
					background-color: #f3f4f6;
				}
			`
		}
	}}
`

export const ButtonGroup = styled.div<{ align?: 'left' | 'center' | 'right' }>`
	display: flex;
	gap: 12px;
	justify-content: ${({ align = 'right' }) => align};
`

export const TimePickerWrapper = styled.div`
	width: 100%;

	/* Style MUI TextField to match our form inputs */
	.MuiTextField-root {
		width: 100%;
		background-color: white;
	}

	.MuiFormControl-root {
		background-color: white !important;
	}

	.MuiPickersTextField-root {
		background-color: white !important;
	}

	.MuiOutlinedInput-root {
		border-radius: 8px;
		font-size: 16px;
		background-color: white !important;
		transition: border-color 0.2s, box-shadow 0.2s;

		&:hover .MuiOutlinedInput-notchedOutline {
			border-color: #9ca3af;
		}

		&.Mui-focused .MuiOutlinedInput-notchedOutline {
			border-color: #3b82f6;
			box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
		}
	}

	.MuiOutlinedInput-notchedOutline {
		border-color: #d1d5db;
	}

	.MuiInputBase-root {
		background-color: white !important;
	}

	.MuiInputBase-input {
		padding: 12px 16px;
		font-size: 16px;
		color: #374151;
		background-color: white !important;
	}

	.MuiInputBase-input::placeholder {
		color: #9ca3af;
		opacity: 1;
	}

	.MuiIconButton-root {
		color: #6b7280;
		padding: 8px;

		&:hover {
			color: #374151;
			background-color: transparent;
		}
	}

	.MuiIconButton-root svg {
		width: 20px;
		height: 20px;
	}
`

export const LinkInputWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
`

export const RemoveLinkButton = styled.button`
	background: #ef4444;
	color: white;
	border: none;
	border-radius: 6px;
	padding: 0.25rem 0.5rem;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background 0.2s;

	&:hover {
		background: #dc2626;
	}
`
